export default __webpack_public_path__ + "static/media/Samira.e63195e9.png";